// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Diamond24Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Diamond24: FC<Diamond24Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="24"
            height="24"
        >
            <path d="m12 21-9-8.9L8 6h8l5 6.1-9 8.9ZM4.575 6 2.45 3.875l1.425-1.4L6 4.6 4.575 6ZM11 4V1h2v3h-2Zm8.375 2L17.95 4.575l2.125-2.125L21.5 3.875 19.375 6ZM12 18.2l5.25-5.2H6.75L12 18.2ZM8.95 8l-2.475 3h11.05L15.05 8h-6.1Z" />
        </svg>
    );
};

export default Diamond24;
